export default "__VITE_ASSET__urfx1D8a__"